import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2262647c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2262647c')) {
      api.createRecord('2262647c', component.options)
    } else {
      api.reload('2262647c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2262647c&", function () {
      api.rerender('2262647c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/official/warehouse/index.vue"
export default component.exports